module.exports = __webpack_public_path__ + "static/img/teeth.dd8fc55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teeth.svg
// module id = TB/a
// module chunks = 1